<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<!-- Creator: CorelDRAW 2020 (64-Bit) -->
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd;"
viewBox="0 0 2000 2000"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
 <defs>
  <style type="text/css">
   <![CDATA[
    .fil0 {fill:#919191}
   ]]>
  </style>
 </defs>
 <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
  <g id="_2193690208992">
   <path class="fil0" d="M976.94 1878.46c-249.05,0 -465.01,-112.46 -590.57,-239.16 -144.74,-146.06 -264.56,-342.7 -264.56,-565.17 0,-176.33 4.5,-273.12 87.37,-437.56 115.87,-229.94 336.5,-404.83 593.54,-456.32 182.86,-36.64 372.22,-13.6 527.05,58.46 93.18,43.37 182.52,104.86 250.5,172.83 544.15,544.16 148.76,1466.92 -603.33,1466.92zm965.2 -936.96l0 153.61c-51.3,603.37 -697.16,1092.65 -1348.68,811.23 -108.8,-46.99 -205.57,-112.9 -283.27,-190.86 -46.25,-46.39 -76.92,-73.82 -115.64,-129.89 -30.3,-43.87 -68.86,-100.41 -89.63,-147.44 -74.56,-168.83 -93.18,-259.24 -93.18,-457.15 0,-344.03 237.85,-681.26 541.68,-829.92 174.32,-85.29 286.95,-92.94 474.32,-92.94 300.34,0 593.13,190.89 750.25,426.61 99.53,149.32 151.27,304.82 164.15,456.75z"/>
   <path class="fil0" d="M824.54 633.87l0 177.8c-149.63,0 -118.53,-37.88 -118.53,203.2l118.53 0 0 584.19 237.07 0 0 -584.19c208.8,0 162.79,13.09 170.86,-74.67 14.64,-159.25 37.37,-128.53 -170.86,-128.53l0 -110.07c0,-111.94 186.26,-17.76 186.26,-84.67 0,-223.29 49.36,-177.79 -220.13,-177.79 -100.94,0 -203.2,93.83 -203.2,194.73z"/>
  </g>
 </g>
</svg>
